


















































































import Vue from "vue";
import Component from "vue-class-component";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import PaginateModel from "@/model/paginate";
import Group from "@/model/group";
import { GroupManagerService } from "@/common/api/services/GroupManagerService";

@Component({
  name: "GroupIndex",
  components: {
    QTableHeader,
    QPaginate,
  },
})
export default class GroupIndex extends Vue {
  public initSearch = {
    keyword: "",
    sort: "created_at",
    direction: "desc",
    perPage: 50,
    currentPage: 1,
  };
  public searchParams = {};
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
    perPage: 50,
  });
  public headers = [
    { id: "created_at", name: "契約日", order: "desc" },
    { id: "name", name: "グループ名", order: "" },
    { id: "contact_type", name: "契約区分" },
    { id: "following_member_num", name: "フォロー" },
    { id: "articles_num", name: "投稿数" },
    { id: "albums_num", name: "アルバム" },
    { id: "files_num", name: "ファイル" },
    { id: "status", name: "ステータス" },
    { id: "", name: "" },
  ];

  public groups: Group[] = [];

  mounted() {
    this.clearSearch();
    this.filter();
  }

  public clearSearch() {
    this.searchParams = { ...this.initSearch };
  }

  public filter(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...query,
      ...this.searchParams,
      ...addition,
    };
    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query: any) {
    const result = await GroupManagerService.adminGroup(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
      perPage: result.data.paginator.perPage,
    });
    this.groups = result.data.groups.map((item) => new Group(item));
  }

  public resetSearch() {
    this.clearSearch();
    this.filter(true);
  }

  public createGroup() {
    this.$router.push({ name: "admin.group-create" });
  }

  public editGroup(groupId) {
    this.$router.push({
      name: "admin.group-edit",
      params: {
        id: groupId,
      },
    });
  }
}
